import React from 'react';
import PageLayout from '../components/PageLayout';
import GettingHere from '../components/GettingHere';
import usePageMeta from '../hooks/usePageMeta';

export default function GettingHerePage() {
  usePageMeta(
    'Getting Here — Flights & Transfers | Hotel Respiro',
    'How to get to Hotel Respiro: direct flights to São Vicente São Pedro International Airport (VXE), e-VOA visa and airport transfers.'
  );

  return (
    <PageLayout>
      <div data-testid="getting-here-page">
        <GettingHere />
      </div>
    </PageLayout>
  );
}
